<template>
  <div>

    <!-- SECCIÓN PRINCIPAL -->
    <transition name="fade">

      <div
        v-if="isVisible"
        class="fotoportada-container"
      >

        <img
          src="@/assets/IMG_6736.jpg.webp"
          alt="Imagen de portada"
          class="fotoportada-img"
        />

        <div class="overlay">

          <div class="contenido-texto centered-text">

          

            <h1 class="nombres2">
            </h1>

            <h1 class="nombres2">
            </h1>

          </div>

        </div>

      </div>

    </transition>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { gsap } from 'gsap'

export default {

  name: 'PortadaBodaElegante',

  setup() {

    const isVisible = ref(true)

    const googleCalendarLink = computed(() => {

      const title =
        encodeURIComponent('Boda de Louiss y Erick')

      const location =
        encodeURIComponent('Santiago, N.L.')

      const details =
        encodeURIComponent('¡Acompáñanos a celebrar nuestra boda!')

      const start = '20251001T190000Z'

      const end = '20251001T230000Z'

      return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${start}/${end}&details=${details}&location=${location}&sf=true&output=xml`

    })

    onMounted(() => {

      const imagen =
        document.querySelector('.fotoportada-img')

      const texto =
        document.querySelector('.centered-text')

      gsap.from(imagen, {

        opacity: 0,

        duration: 1.5,

        ease: 'power2.out'

      })

      gsap.from(texto, {

        y: 50,

        opacity: 0,

        duration: 1,

        ease: 'power2.out',

        delay: 0.5

      })

    })

    return {

      isVisible,

      googleCalendarLink

    }

  }

}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500&display=swap');

/* ========= CONTENEDOR ========= */

.fotoportada-container{
  position:relative;
  width:100%;
  min-height:100vh;
  overflow:hidden;
  display:flex;
  align-items:flex-start;
  justify-content:center;
}

/* ========= IMAGEN ========= */

.fotoportada-img{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
}

/* ========= OVERLAY ========= */

.overlay{
  position:absolute;
  inset:0;
  background:rgba(0,0,0,0.411);
  display:flex;

  /* 🔹 ARRIBA */
  justify-content:center;
  align-items:flex-start;

  text-align:center;
  z-index:2;
  padding:90px 20px 20px;
  box-sizing:border-box;
}

/* ========= TEXTO ========= */

.centered-text{
  color:white;
  font-family:'Playfair Display', serif;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  gap:10px;
  width:100%;
  max-width:700px;
  box-sizing:border-box;
}

.nombres{
  font-family:'nombres2', serif !important;
  font-size:clamp(48px,9vw,72px);
  line-height:1.1;
  letter-spacing:1px;
  color:#fff;
  text-align:center;
  margin:0;
}

.nombres2{
  font-size:20px;
  line-height:1.4;
  letter-spacing:1px;
  font-family:'Playfair Display', serif;
  color:#fff;
  margin:0;
  text-align:center;
}

/* ========= AMPERSAND ========= */

.ampersand{
  font-size:70px;
  line-height:0.8;
  color:white;
  opacity:.25;
  font-family:'padres', serif;
  margin:0;
}

/* ========= FECHA ========= */

.fecha-evento{
  font-size:16px;
  letter-spacing:2px;
  color:#f3f3f3;
  text-align:center;
}

/* ========= BOTÓN ========= */

.boton-agendar{
  background-color:rgba(255,255,255,.2);
  border:1px solid #fff;
  padding:10px 22px;
  border-radius:25px;
  color:white;
  font-size:13px;
  font-weight:600;
  letter-spacing:1px;
  cursor:pointer;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  text-decoration:none;
  transition:.3s ease;
}

.boton-agendar:hover{
  background-color:rgba(255,255,255,.4);
}

/* ========= FOOTER ========= */

.footer-bar{
  position:absolute;
  bottom:0;
  left:0;
  width:100%;
  min-height:50px;
  background-color:#3b3b3b;
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:12px 20px;
  color:white;
  font-family:'Playfair Display', serif;
  font-size:11px;
  letter-spacing:1px;
  z-index:3;
  box-sizing:border-box;
}

.footer-text{
  line-height:1.3;
  text-align:left;
}

.footer-menu{
  font-size:18px;
}

/* ========= UTILIDAD ========= */

.invisible{
  visibility:hidden;
}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .fotoportada-container{
    min-height:100vh;
  }

  .overlay{
    padding:70px 16px 20px;
  }

  .centered-text{
    gap:8px;
  }

  .nombres{
    font-size:clamp(40px,12vw,60px);
  }

  .nombres2{
    font-size:18px;
  }

  .ampersand{
    font-size:58px;
  }

  .footer-bar{
    flex-direction:column;
    gap:6px;
    text-align:center;
  }

  .footer-text{
    text-align:center;
  }

}
</style>